import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_date_format = _resolveDirective("date-format")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "change-log-wrap" }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_pagination, {
        background: "",
        class: "cm-ui-pd20",
        small: "",
        style: {"text-align":"center"},
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.pagination.currentPage,
        "page-sizes": [10, 20, 30, 50, 100],
        "page-size": _ctx.pagination.pageSize,
        total: _ctx.pagination.total,
        layout: "total, sizes, prev, pager, next, jumper"
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        "empty-text": _ctx.$t('common.noData'),
        data: _ctx.tableData,
        width: "100%",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            property: "time",
            label: _ctx.$t('listColumns.time'),
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_date_format, scope.row.time * 1000]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            property: "change_type",
            label: _ctx.$t('groupClient.terminalInfoDetail.changeColChangeItem'),
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.changeTypeLabelMap[scope.row.change_type] ?? '--'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            property: "origin_setting",
            label: _ctx.$t('groupClient.terminalInfoDetail.changeColOriginSetting')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            property: "new_setting",
            label: _ctx.$t('groupClient.terminalInfoDetail.changeColNewSetting')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["empty-text", "data"])
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.isLoading]
  ])
}